//import Uiconstants from "../../lib/UIconstants"
import QuestStatusBarController from '../../controllers/quest/QuestStatusBarController';
import MainGridController from '../../controllers/grid/MainGridController';
import { COMPONENTS } from '../../lib/constants';
import { QuestStatusBarGrid } from './QuestStatusBarGrid';

export const QuestStatusBarView = {
	name: COMPONENTS.QUEST_STATUS_BAR,
	position: {
		x: 0,
		y: 0
	},
	controllers: [
		{
			Controller: QuestStatusBarController,
			name: 'QuestStatusBarController',
			config: {
				item: 'texts',
				val: 'texts',
				position: { x: 0, y: 120, w: 634 }
			}
		},
		{
			Controller: MainGridController,
			name: 'QuestStatusBarGrid',
			config: QuestStatusBarGrid
		}
	],
	components: [
		{
			name: 'bg',
			type: 'Sprite',
			position: { x: 0, y: 0 },
			components: [
				{
					name: 'bg',
					type: 'Sprite',
					img: 'bonus_reel_indicator',
					position: { x: 0, y: 0 }
				},
				{
					name: 'texts',
					type: 'Sprite',
					components: [
						{
							name: 'FREE_SPIN_LEFT',
							type: 'Text',
							text: 'FREE_SPIN_LEFT',
							position: { x: 50, y: 15 }
						},
						{
							name: 'FREE_SPIN_LEFT_AMOUNT',
							type: 'Text',
							text: 'FREE_SPIN_LEFT_AMOUNT',
							position: { x: 255, y: 15 }
						},
						{
							name: 'FREE_SPIN_WIN',
							type: 'Text',
							text: 'FREE_SPIN_WIN',
							position: { x: 355, y: 15 }
						},
						{
							name: 'FREE_SPIN_WIN_AMOUNT',
							type: 'Text',
							text: 'FREE_SPIN_WIN_AMOUNT',
							position: { x: 480, y: 15 }
						}
					]
				}
			]
		}
	]
};
